<svg viewBox="0 0 58 58" aria-hidden="true">
  <rect width="58" height="58" fill="var(--ds-surface-muted)" />
  <path
    d="M0 18 H58 M0 38 H58 M16 0 V58 M44 0 V58"
    stroke="var(--ds-border-default)"
    stroke-width="3"
  />
  <path d="M0 48 L58 44" stroke="var(--ds-border-default)" stroke-width="2" />
  <circle cx="30" cy="28" r="11" fill="var(--pin)" opacity=".13" />
  <path
    d="M30 19a6 6 0 0 0-6 6c0 4.6 6 10.5 6 10.5s6-5.9 6-10.5a6 6 0 0 0-6-6Z"
    fill="var(--pin)"
  />
  <circle cx="30" cy="25" r="2.3" fill="#fff" />
</svg>
